// File size limits
export const MAX_IMAGE_FILE_SIZE = 10 * 1024 * 1024; // 10MB
export const MAX_AUDIO_FILE_SIZE = 25 * 1024 * 1024; // 25MB (Whisper API limit)

// Family limits
export const MAX_FAMILIES_PER_STORY = 4;

export const RELATIONSHIPS = [
  'Padre',
  'Madre',
  'Hijo',
  'Hija',
  'Hermano',
  'Hermana',
  'Abuelo',
  'Abuela',
  'Tío',
  'Tía',
  'Primo',
  'Prima',
  'Esposo',
  'Esposa',
  'Otro familiar'
];

export const DEVELOPMENTAL_STAGES = [
  '0-3 meses',
  '3-6 meses',
  '6-12 meses',
  '1-2 años',
  '2-3 años',
  '3-5 años',
  '5-8 años',
  '8-12 años',
  '12+ años'
];

// Memoir generation thresholds
export const MEMOIR_COMPLETION_THRESHOLD = 0.75;
export const MEMOIR_CHAPTER_LOW_THRESHOLD = 0.50;

// Total topic count across all chapter_templates × question_templates.
// Used to estimate completion time in the FrequencyPicker. Update if the
// master question set grows or shrinks. Source of truth lives in
// supabase/migrations/* (chapter_templates seed + question_templates seed).
export const TOTAL_STORY_TOPICS = 42;

export const MEMORY_TAGS = [
  { name: 'Primera vez', type: 'category' },
  { name: 'Sonrisa', type: 'category' },
  { name: 'Juego', type: 'category' },
  { name: 'Comida', type: 'category' },
  { name: 'Sueño', type: 'category' },
  { name: 'Palabra nueva', type: 'category' },
  { name: 'Logro', type: 'achievement' },
  { name: 'Habilidad nueva', type: 'achievement' }
];